import React, { useState, useEffect } from 'react';
import { BottomNavigation } from './BottomNavigation';
import { GlobalSearch } from '../GlobalSearch';
import { ThemeToggle } from '../ThemeToggle';

export const AppLayout = ({ children }) => {
  const [showSearch, setShowSearch] = useState(false);

  // Global keyboard shortcut: Cmd/Ctrl + K
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setShowSearch(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      {showSearch && <GlobalSearch onClose={() => setShowSearch(false)} />}
      
      <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pb-16">
        {/* Theme Toggle - Fixed Position */}
        <div className="fixed top-4 right-4 z-50">
          <ThemeToggle size="icon" className="bg-white dark:bg-gray-800 shadow-lg" />
        </div>

        {/* Main Content */}
        <main className="max-w-screen-xl mx-auto">
          {children}
        </main>

        {/* Bottom Navigation */}
        <BottomNavigation />
      </div>
    </>
  );
};
